import { inject, Injectable } from '@angular/core';
import { CommonService } from '../common.service';
import { OverviewReportRequestData } from '../customer-report.service';
import { Observable } from 'rxjs';
import { OverviewReportResponse } from '../../components/report/report.model';

@Injectable({
  providedIn: 'root',
})
export class CustomerReportApiService {
  private readonly commonService = inject(CommonService);

  constructor() {}

  getOverviewReport(requestData: OverviewReportRequestData): Observable<OverviewReportResponse> {
    return this.commonService.postRequest('api/calculate-overview-report', requestData);
  }
}
